import {
    Document,
    Page,
    View,
    Text,
    Image,
    StyleSheet,
    Font,
} from '@react-pdf/renderer';

import NotoSansDevanagariR from '../font/NotoSansDevanagari-Regular.ttf';
import NotoSansDevanagariB from '../font/NotoSansDevanagari-Bold.ttf';

// Font Registration
Font.register({
    family: 'NotoSansDevanagari',
    fonts: [
        { src: NotoSansDevanagariR, fontWeight: 'normal' },
        { src: NotoSansDevanagariB, fontWeight: 'bold' },
    ],
});

// Helpers
const formatDate = (date) => {
    try {
        const d = date instanceof Date ? date : new Date(date);
        if (isNaN(d)) return String(date);
        return d.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    } catch {
        return String(date);
    }
};

const formatShortDate = (date) => {
    try {
        const d = date instanceof Date ? date : new Date(date);
        if (isNaN(d)) return date || '________';
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = d.getFullYear();
        return `${dd}-${mm}-${yyyy}`;
    } catch {
        return date || '________';
    }
};

const styles = StyleSheet.create({
    page: {
        fontFamily: 'NotoSansDevanagari',
        padding: 60,
    },

    date: {
        fontSize: 11,
        marginBottom: 20,
        top: '8%'
    },
    title: {
        fontSize: 13,
        fontWeight: 'bold',
        textAlign: 'center',
        marginVertical: 10,
        textTransform: 'uppercase',
        textDecoration: 'underline',
    },
    body: {
        fontSize: 11,
        // lineHeight: 1.6,
        textAlign: 'justify',
        marginTop: 10,
    },
    strong: {
        fontWeight: 'bold',
    },
    content: {
        marginTop: '15%',
    },
    signatureRow: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginTop: 20,
        // marginBottom: 120,
    },
    stamp: {
        width: 70,
        height: 70,
        marginRight: 12,
    },
    signatureBox: {
        flex: 1,
    },
    printedName: {
        fontSize: 11,
        fontWeight: 'bold',
        marginTop: 6,
    },
    printedTitle: {
        fontSize: 10,
        marginTop: 2,
    },
    signature: {
        width: 120,
        height: 40,
    },
    watermark: {
        position: 'absolute',
        top: '25%',
        left: '25%',
        width: '40%',
        opacity: 0.1,
    },
    pdfHeader: {
        position: 'absolute',
        top: '3%',
        left: '6%',
        width: '30%',
    },
    contactBlock: {
        position: 'absolute',
        left: 40,
        right: 40,
        bottom: 40,
        borderTop: '0.5pt solid #0b0b0b',
        paddingTop: 8,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    contactText: {
        fontSize: 8,
    },
    websiteContainer: {
        position: 'absolute',
        left: 40,
        right: 40,
        bottom: 12,
        alignItems: 'center',
    },
    hr: {
        width: '100%',
        height: 0.5,
        backgroundColor: '#0b0b0b',
    },
    websiteText: {
        fontSize: 7,
        textAlign: 'center',
        marginTop: 4,
        color: '#333',
    },

    signSealRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 30,
    },
    signBlock: {
        width: '50%',
    },
    sealBlock: {
        width: '50%',
        alignItems: 'flex-end',
        marginLeft:20
    },
    sealImage: {
        width: 60,
        height: 60,
    },

});

const JoiningLetterPDF = ({
    employee = {},
    companyName = '',
    companyLogo,
    complete_logo,
    signatureImage,
    shikka,
    stampImage,
    signatoryName = '',
    signatoryTitle = '',
    companyAddress1 = '',
    companyAddress2 = '',
    contact = '',
    companyWebsite = '',
    issueDate = new Date(),
}) => {
    const { name = '', designation = '', startDate = '', endDate = '' } = employee;

    const heading = 'TO WHOMSOEVER IT MAY CONCERN';
    const para3 = `We wish to put on record the good services provided by ${name?.split(' ')[0] || '________'
        } to the organization during his tenure with us. We wish ${name?.split(' ')[0] || '________'
        } success in all his future endeavors.`;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* Date */}
                <Text style={{ ...styles.date, textAlign: 'right' }}>{formatDate(issueDate)}
                </Text>
                {/* Watermark & Header */}
                {companyLogo && <Image src={companyLogo} style={styles.watermark} />}
                {complete_logo && <Image src={complete_logo} style={styles.pdfHeader} />}

                {/* Content */}
                <View style={styles.content}>
                    <Text style={styles.title}>{"Joining Report"}</Text>


                    <View style={styles.signatureRow}>
                        <View style={styles.signatureBox}>

                            <Text style={styles.body}>To, </Text>
                            <Text style={styles.printedName} >The Principal,</Text>
                            <Text style={styles.printedTitle}>Government Polytechnic, Mumbai, </Text>
                            <Text style={styles.printedTitle}>Kherwadi, Bandra (E), </Text>
                            <Text style={styles.printedTitle}>Mumbai – 400 051. </Text>
                        </View>
                    </View>

                    <Text style={{ ...styles.body, marginTop: 30, marginLeft: 30 }}>
                        <Text style={styles.strong}>Subject : </Text>Joining report for the In Plant training
                    </Text>

                    <Text style={{ ...styles.body, marginBottom: 30, marginLeft: 30 }}>
                        <Text style={styles.strong}>Reference : </Text> In-Plant Training Approval
                    </Text>


                    <Text style={{ ...styles.body }}>
                        <Text>Respected Sir/Madam, </Text>
                    </Text>

                    <Text style={styles.body}>
                        With reference to above subject, <Text style={styles.strong}>{name}</Text>, student of Govt. Polytechnic Mumbai,
                        has joined for the In Plant Training at <Text style={styles.strong}>{companyName}</Text> on 08/12/2025.
                    </Text>

                    <View style={styles.signSealRow}>

                        {/* Signature Block (Left) */}
                        <View style={styles.signBlock}>
                            {signatureImage && (
                                <Image
                                    src={signatureImage}
                                    style={{ ...styles.signature, marginTop: 20 }}
                                />
                            )}
                            <Text style={{ ...styles.printedName, marginTop: 8 }}>
                                Mr. Navnath Atmaram Adsul
                            </Text>
                            <Text style={styles.printedTitle}>
                                Signature of the Industry Personnel
                            </Text>
                        </View>

                        {/* Seal / Shikka Block (Right) */}
                        <View style={styles.sealBlock}>
                            {shikka && (
                                <Image
                                    src={shikka}
                                    style={styles.sealImage}
                                />
                            )}
                            <Text style={{ ...styles.printedTitle, marginTop: 6 }}>
                                Seal of the Organization
                            </Text>
                        </View>

                    </View>


                </View>

                {/* Footer */}
                <View style={styles.contactBlock}>
                    <View style={{ flex: 1 }}>
                        {companyAddress1 && <Text style={styles.contactText}>{companyAddress1}</Text>}
                        {companyAddress2 && <Text style={styles.contactText}>{companyAddress2}</Text>}
                    </View>
                    <View style={{ width: 200, textAlign: 'right' }}>
                        {contact &&
                            contact
                                .split(/\r?\n|\|/)
                                .map((line, idx) => (
                                    <Text key={idx} style={styles.contactText}>
                                        {line.trim()}
                                    </Text>
                                ))}
                    </View>
                </View>

                {companyWebsite && (
                    <View style={styles.websiteContainer}>
                        <View style={styles.hr} />
                        <Text style={styles.websiteText}>{companyWebsite}</Text>
                    </View>
                )}
            </Page>
        </Document>
    );
};

export default JoiningLetterPDF;
